import { PartialType } from '@nestjs/swagger';
import { CreateVendedorCobradorDto } from './create-vendedor-cobrador.dto';

export class UpdateVendedorCobradorDto extends PartialType(CreateVendedorCobradorDto) {}
